import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  apiKeyValueAll: [],
  apiKeyValue: {},
  selectedCategory: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "keyName",
  sortOrder: "asc",
};

const apiKeyValueSlice = createSlice({
  name: "apiKeyValue",
  initialState,
  reducers: {
    setApiKeyValueAll: (state, action) => {
      state.apiKeyValueAll = action.payload;
    },
    setApiKeyValue: (state, action) => {
      state.apiKeyValue = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
});

export const {
  setApiKeyValueAll,
  setApiKeyValue,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
  setSelectedCategory,
} = apiKeyValueSlice.actions;

export default apiKeyValueSlice.reducer;
